import {
  BASIC_DATA_TABLE_MAX_ITEMS,
  FWD_CHART_MAX_ITEMS,
  HIGHLIGHTED_PRICE_MAX_ITEMS,
  SEASONAL_CHART_MAX_ITEMS,
  SPOT_CHART_MAX_ITEMS
} from '@/features/Dashboard/constants/const';
import { AppType } from '@/features/Dashboard/types';

export default function getMaxItemsForType(type: AppType | undefined) {
  switch (type) {
    case AppType.Spot:
      return SPOT_CHART_MAX_ITEMS;
    case AppType.FWD:
      return FWD_CHART_MAX_ITEMS;
    case AppType.Seasonal:
      return SEASONAL_CHART_MAX_ITEMS;
    case AppType.Table:
      return BASIC_DATA_TABLE_MAX_ITEMS;
    case AppType.Tiles:
      return HIGHLIGHTED_PRICE_MAX_ITEMS;
    default:
      return 0;
  }
}
